// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"8ecd589f","194":"49b79f10","485":"1235a4da","694":"f73021b2","731":"a8ebda70","787":"463995b5"}[chunkId] + ".chunk.js";
};